import { render, staticRenderFns } from "./ComentariosForm.vue?vue&type=template&id=c614feb2&"
import script from "./ComentariosForm.vue?vue&type=script&lang=js&"
export * from "./ComentariosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports